module.exports = __webpack_public_path__ + "jtails-build/img/checkout-success.86dc26ed.svg";